import type React from 'react'
import { PORT_HIT_SIZE } from '@/lib/text-linking/text-linking-geometry'

import { PORT_STROKE_COLOR } from '../constants/port-style'

// Keyboard focus ring (WMPCM-9198). Deliberately NOT `PORT_HIT_SIZE`: `text-linking-layer.test.tsx`
// resolves a port's hit rect with `rect[width="24"][height="24"]`, so a second rect at that exact
// size would make those queries ambiguous. Larger also reads better — a ring around the port rather
// than one tracing its hit area.
const PORT_FOCUS_RING_SIZE = PORT_HIT_SIZE + 6
const PORT_FOCUS_RING_RADIUS = 6

/**
 * Keyboard focus indicator for a port. Drawn as an SVG primitive rather than a CSS
 * `focus-visible:outline` because `outline` on SVG child elements is inconsistently supported,
 * while a `<rect>` is guaranteed to paint. It sits inside its port's own transform group, in the
 * same screen pixels as the square it rings, so it stays a fixed on-screen size right alongside it.
 */
export function PortFocusRing({ visible }: { visible: boolean }): React.JSX.Element | null {
  if (!visible) return null

  return (
    <rect
      x={-PORT_FOCUS_RING_SIZE / 2}
      y={-PORT_FOCUS_RING_SIZE / 2}
      width={PORT_FOCUS_RING_SIZE}
      height={PORT_FOCUS_RING_SIZE}
      rx={PORT_FOCUS_RING_RADIUS}
      fill="none"
      stroke={PORT_STROKE_COLOR}
      strokeWidth={2}
      pointerEvents="none"
      aria-hidden="true"
    />
  )
}
